







































































import Vue from "vue";

// Vuex
import { RootState } from "@/store";
import { mapState, mapActions } from "vuex";
import * as a from "@/store/modules/ApplicationModule/actions";

//Model
import { TagValues } from "@/model/data/Tag";

export default Vue.extend({
    data() {
        return {
            loading: false,
            selectedTagKey: null,
            selectedTagValues: [],
            sentTagKey: null,
            sentTagValues: [],
            applied: false,
        };
    },
    props: {
        value: {},
        buttonMode: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            availableTags: (state: RootState): TagValues[] => state.application.availableTags,
        }),

        canApply() {
            return this.selectedTagKey && this.selectedTagValues.length;
        },
    },
    methods: {
        ...mapActions([a.GET_AVAILABLE_TAGS]),

        open() {
            this.selectedTagKey = this.sentTagKey;
            this.selectedTagValues = this.sentTagValues;
        },

        onApply() {
            console.log("onApply()");
            var tagValues: TagValues = new TagValues();
            tagValues.tagName = this.selectedTagKey;
            tagValues.availableValues = this.selectedTagValues;
            this.$emit("input", tagValues);
            this.sentTagKey = this.selectedTagKey;
            this.sentTagValues = this.selectedTagValues;
            this.applied = true;
        },

        deleteFilters() {
            this.selectedTagKey = null;
            this.sentTagKey = null;
            this.selectedTagValues = [];
            this.sentTagValues = [];
            this.applied = false;
            this.$emit("input");
        },
    },
    async mounted() {
        this.loading = true;

        if (this.availableTags == null || !this.availableTags.length) await this[a.GET_AVAILABLE_TAGS]();

        if (this.availableTags.map((c) => c.tagName).includes((this.value as TagValues).tagName)) {
            this.selectedTagKey = (this.value as TagValues).tagName;
            this.selectedTagValues.splice(0, this.selectedTagValues.length, ...(this.value as TagValues).availableValues);
        }

        this.loading = false;
    },
});
